const RepublicOfMacedoniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112197)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M23.0416 39.7701C26.2944 39.2738 29.2886 37.9929 31.8272 36.128L20 20L23.0416 39.7701Z"
        fill="#D80027"
      />
      <path
        d="M16.9586 0.230469C13.7058 0.726719 10.7116 2.00766 8.17285 3.87242L20.0002 20.0005L16.9586 0.230469Z"
        fill="#D80027"
      />
      <path
        d="M8.17285 36.128C10.7114 37.9928 13.7057 39.2738 16.9584 39.7702L20.0002 20L8.17285 36.128Z"
        fill="#D80027"
      />
      <path
        d="M3.87193 8.17285C2.00709 10.7116 0.726309 13.7057 0.22998 16.9586L20.0001 20.0002L3.87193 8.17285Z"
        fill="#D80027"
      />
      <path
        d="M0.22998 23.0416C0.726231 26.2944 2.00717 29.2886 3.87201 31.8272L20.0001 20L0.22998 23.0416Z"
        fill="#D80027"
      />
      <path
        d="M39.7701 16.9585C39.2738 13.7057 37.9929 10.7115 36.128 8.17285L20 20.0001L39.7701 16.9585Z"
        fill="#D80027"
      />
      <path
        d="M31.8272 3.87234C29.2885 2.00758 26.2944 0.726719 23.0416 0.230469L20 20.0005L31.8272 3.87234Z"
        fill="#D80027"
      />
      <path
        d="M36.1282 31.8273C37.993 29.2886 39.2738 26.2943 39.7702 23.0416L20 20L36.1282 31.8273Z"
        fill="#D80027"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#D80027"
      />
      <path
        d="M20.0001 25.218C22.8816 25.218 25.2176 22.8821 25.2176 20.0006C25.2176 17.1191 22.8816 14.7832 20.0001 14.7832C17.1186 14.7832 14.7827 17.1191 14.7827 20.0006C14.7827 22.8821 17.1186 25.218 20.0001 25.218Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112197">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RepublicOfMacedoniaSvg;
